// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-readonly .v-input_slot:focus {\n  border-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
